/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationsCommandRequest
 */
export interface MatchOperationsCommandRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsCommandRequest
     */
    command?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsCommandRequest
     */
    period?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsCommandRequest
     */
    elapsedMs?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsCommandRequest
     */
    clientEventId?: string | null;
}

/**
 * Check if a given object implements the MatchOperationsCommandRequest interface.
 */
export function instanceOfMatchOperationsCommandRequest(value: object): value is MatchOperationsCommandRequest {
    return true;
}

export function MatchOperationsCommandRequestFromJSON(json: any): MatchOperationsCommandRequest {
    return MatchOperationsCommandRequestFromJSONTyped(json, false);
}

export function MatchOperationsCommandRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsCommandRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'command': json['command'] == null ? undefined : json['command'],
        'period': json['period'] == null ? undefined : json['period'],
        'elapsedMs': json['elapsedMs'] == null ? undefined : json['elapsedMs'],
        'clientEventId': json['clientEventId'] == null ? undefined : json['clientEventId'],
    };
}

export function MatchOperationsCommandRequestToJSON(json: any): MatchOperationsCommandRequest {
    return MatchOperationsCommandRequestToJSONTyped(json, false);
}

export function MatchOperationsCommandRequestToJSONTyped(value?: MatchOperationsCommandRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'command': value['command'],
        'period': value['period'],
        'elapsedMs': value['elapsedMs'],
        'clientEventId': value['clientEventId'],
    };
}

